import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zb89yc9qc: FaireProductEntity = {
  token: "p_6zb89yc9qc",
  type: "product",
  name: "Faux Leather A-Line Midi Skirt",
  brandToken: "b_7nbwqw0mwh",
  brandName: "Current Air",
  imageUrl:
    "https://cdn.faire.com/fastly/3168162cad1f0756b57598f24363158018d072d064d45c3b5a542660a075736e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b587b558edda45fdc890a20a4d6e21561cf1387d68ee7eeaf3d8dd91847bca9.jpeg",
    "https://cdn.faire.com/fastly/e14174e5e525fedc0c119b118bb64d0b2f31ed0d8df3528e34d410eaf6867c65.jpeg",
    "https://cdn.faire.com/fastly/dbd6edc94fed0371ebcebaab2552aa6c55bba70469e7950627e86c95abf41a65.jpeg",
    "https://cdn.faire.com/fastly/bfb7efd1002033a47a0b6b02d30e4f2a97164a7ca1f37b45259f587115c982e1.jpeg",
    "https://cdn.faire.com/fastly/663d0482d4091357b9e8148a2bd277606f2cea256861bcfb4f6a3f84bd458828.jpeg",
    "https://cdn.faire.com/fastly/b1f1c12dbcd3204abc466ecf3d77fe42f24b26c5be9193b92c4601810269ecd4.jpeg",
    "https://cdn.faire.com/fastly/ca3685fb24adbf1fd343b3271976a5cdba33be742ef277572c1209eb9d3c8744.jpeg",
    "https://cdn.faire.com/fastly/8517e700acac3de3457bf802ad4fe169f65ee31b6d8d6ea57294fbef9b1b1949.jpeg",
    "https://cdn.faire.com/fastly/68e7c166504097bf8e1786fad411427624668ec5fe728e72720d1b122d6cc5ac.jpeg",
    "https://cdn.faire.com/fastly/7d0f758f34c782c6d103125e08198f5ed168e4fe89c747b7d2a9074ee08ad241.jpeg",
    "https://cdn.faire.com/fastly/5952432fe3a7bfe62a230163a6861cdf44c2b8dbf087f17b522a425da6340a50.jpeg",
  ],
  priceDollars: 294,
  description:
    "-Faux leather skirt\n-Elasticized waist\n-Panel seam detail\n-A-line flared hem\n-Pull-on style\n-Midi length\n-Hand wash cold separately",
  tags: [],
  msrpDollars: 588,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:54.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
